export type AuthorProfileSummary = {
  title?: string | null;
  profile_image?: string | null;
  gender?: "MALE" | "FEMALE" | null;
};

export type AuthorSummary = {
  id: string;
  email: string;
  role: "ADMIN" | "OPERATOR" | "USER";
  isProfileComplete?: boolean;
  name_en?: string | null;
  sur_name_en?: string | null;
  name_fa?: string | null;
  sur_name_fa?: string | null;
  profile?: AuthorProfileSummary | null;
};

const hasValue = (value: string | null | undefined) =>
  typeof value === "string" && value.trim().length > 0;

export function isAuthorProfileComplete(author: Partial<AuthorSummary> | null | undefined) {
  if (!author) return false;
  return (
    hasValue(author.name_en) &&
    hasValue(author.sur_name_en) &&
    hasValue(author.name_fa) &&
    hasValue(author.sur_name_fa)
  );
}

export function getAuthorProfileMissingFields(
  author: Partial<AuthorSummary> | null | undefined,
) {
  return {
    name_en: !hasValue(author?.name_en),
    sur_name_en: !hasValue(author?.sur_name_en),
    name_fa: !hasValue(author?.name_fa),
    sur_name_fa: !hasValue(author?.sur_name_fa),
  };
}
